import * as breakpoints from "../styles/breakpoints";
import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import * as fontWeights from "../styles/fontWeights";
import appStyles from "../styles/appStyles";
import CircularProgress from "./mui/CircularProgress";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
	button: {
		padding: "8px 12px",
		borderRadius: 2,
		display: "inline-block",
		textDecoration: "none",
		textTransform: "uppercase",
		color: colors.docketLightishBlue,
		fontSize: 14,
		fontWeight: fontWeights.MEDIUM,
		backgroundColor: colors.transparent,
		whiteSpace: "nowrap",
		overflow: "hidden",
		opacity: 0.8,
		transition: "opacity 0.3s",
		position: "relative",
		lineHeight: "normal",
	},
	hover: {
		cursor: "pointer",
		opacity: 1.0,

		[breakpoints.desktopTrue]: {
			":hover": {
				backgroundColor: colors.docketLightGrey20,
			},
		},
	},
	float: {
		backgroundColor: colors.docketLightishBlue,
		boxShadow: `0px 3px 6px ${colors.transparentBlack5}`,
		paddingTop: 6,
		paddingBottom: 6,
		paddingLeft: 22,
		paddingRight: 22,
		color: colors.white,
		opacity: 1.0,
	},
	hoverFloat: {
		cursor: "pointer",
		transition: "opacity 0.3s",

		[breakpoints.desktopTrue]: {
			":hover": {
				opacity: 0.8,
			},
		},
	},
	spinnerContainer: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	visible: {
		opacity: 1.0,
		height: "100%",
	},
	invisible: {
		opacity: 0.0,
	},
});

export default class LoaderButton extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		aStylesDisabled: docketPropTypes.aphroditeStyles,
		children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
		disabled: PropTypes.bool.isRequired,
		floating: PropTypes.bool.isRequired,
		href: PropTypes.string,
		loading: PropTypes.bool,
		loadingColor: PropTypes.string.isRequired,
		loadingSize: PropTypes.number.isRequired,
		onClick: PropTypes.func,
	};

	static defaultProps = {
		floating: false,
		disabled: false,
		loading: false,
		loadingColor: colors.docketGrey,
		loadingSize: 16,
	};

	_saveRef = ref => (this.ref = ref);

	render() {
		let hoverStyle = null;
		if (!this.props.disabled) {
			hoverStyle = this.props.floating ? styles.hoverFloat : styles.hover;
		}

		const className = css(
			appStyles.baseFont,
			styles.button,
			hoverStyle,
			this.props.floating && styles.float,
			this.props.aStyles,
			this.props.disabled && this.props.aStylesDisabled,
		);

		return (
			<a
				ref={this._saveRef}
				className={className}
				href={this.props.disabled || !this.props.href ? null : this.props.href}
				onClick={this.props.disabled ? null : this.props.onClick}
			>
				<div className={css(this.props.loading ? styles.invisible : styles.visible)}>
					{this.props.children}
				</div>
				<div
					className={css(
						styles.spinnerContainer,
						this.props.loading ? styles.visible : styles.invisible,
					)}
				>
					<CircularProgress
						size={this.props.loadingSize}
						thickness={2}
						color={this.props.loadingColor}
					/>
				</div>
			</a>
		);
	}
}
